import React, { createContext, useContext, useState, useCallback } from 'react'

const AnimationStartContext = createContext()

export const AnimationStartProvider = ({ children }) => {
  const [welcomeDismissed, setWelcomeDismissed] = useState(false)

  const dismissWelcome = useCallback(() => {
    setWelcomeDismissed(true)
  }, [])

  return (
    <AnimationStartContext.Provider value={{ welcomeDismissed, dismissWelcome }}>
      {children}
    </AnimationStartContext.Provider>
  )
}

export const useAnimationStart = () => {
  return useContext(AnimationStartContext)
}
